var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22447_27916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.02693 7.23345L3.61621 7.66738L4.018 5.22453L8.62246 0.636133C8.69716 0.560815 8.78604 0.501034 8.88396 0.460238C8.98188 0.419441 9.08692 0.398437 9.193 0.398438C9.29908 0.398437 9.40411 0.419441 9.50203 0.460238C9.59995 0.501034 9.68883 0.560815 9.76353 0.636133L10.6153 1.48792C10.6906 1.56262 10.7504 1.6515 10.7912 1.74942C10.832 1.84734 10.853 1.95237 10.853 2.05845C10.853 2.16454 10.832 2.26957 10.7912 2.36749C10.7504 2.46541 10.6906 2.55429 10.6153 2.62899L6.02693 7.23345Z",
    stroke: "#6C757D",
    strokeWidth: 0.803571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64293 7.63616V10.0469C9.64293 10.26 9.55827 10.4644 9.40757 10.6151C9.25687 10.7658 9.05248 10.8504 8.83936 10.8504H1.20543C0.992307 10.8504 0.787915 10.7658 0.637216 10.6151C0.486517 10.4644 0.401855 10.26 0.401855 10.0469V2.41295C0.401855 2.19983 0.486517 1.99543 0.637216 1.84474C0.787915 1.69404 0.992307 1.60938 1.20543 1.60938H3.61614",
    stroke: "#6C757D",
    strokeWidth: 0.803571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22447_27916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.25,
    height: 11.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d00ad4aad2e3f5485bea6a3ef32876fc.svg";
export { ForwardRef as ReactComponent };